import get from "lodash/get";

export const getMenuItems = cards => {
  const storyCards = [...cards];
  let menus = [];

  storyCards.forEach(card => {
    const newCard = Object.assign({}, card);
    const { metadata, id } = newCard;

    const menu = get(metadata, ["attributes", "menulabel", 0], null);
    if (menu) {
      menus = [
        ...menus,
        Object.assign(
          {},
          {
            id,
            menu
          }
        )
      ];
    }
  });

  return menus;
};
